import { differenceInCalendarDays, parseISO } from 'date-fns';

export interface DeliveryPoint {
  x: number;
  dia: number;
  acumulado: number;
}

function edadDeEntrega(fecha: string, fechaEntrada: string): number {
  return Math.max(differenceInCalendarDays(parseISO(fecha), parseISO(fechaEntrada)) + 1, 1);
}

export function crearPuntosEntregaAcumulados(
  entregas: Array<{ fecha: string; kg: number | string }>,
  fechaEntrada: string,
): DeliveryPoint[] {
  const repeticionesPorEdad = new Map<number, number>();
  const puntos: DeliveryPoint[] = [];
  let acumulado = 0;
  for (const entrega of entregas) {
    const kg = Number(entrega.kg);
    if (!Number.isFinite(kg)) continue;
    const dia = edadDeEntrega(entrega.fecha, fechaEntrada);
    const repeticion = repeticionesPorEdad.get(dia) ?? 0;
    repeticionesPorEdad.set(dia, repeticion + 1);
    acumulado += kg;
    puntos.push({
      dia,
      x: dia + (repeticion + 1) * 0.12,
      acumulado,
    });
  }
  return puntos;
}
